import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getTopEvolucionSiniestros } from '../api/informesApi'

export const useTopEvolucionSiniestros = (trigger, periodoData, contrato) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!trigger || !contrato || !periodoData?.fechaDesde || !periodoData?.fechaHasta) return

    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await getTopEvolucionSiniestros(contrato, periodoData.fechaDesde, periodoData.fechaHasta, {
          signal: controller.signal,
        })
        const sorted = [...response.data]
          .map((item) => {
            let formattedPeriodo = item.periodo
            formattedPeriodo = `${formattedPeriodo.substring(0, 4)}/${formattedPeriodo.substring(4)}`
            return { ...item, periodo: formattedPeriodo }
          })
          .sort((a, b) => a.periodo.localeCompare(b.periodo))
        setData(sorted)
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setData([])
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, contrato, periodoData?.fechaDesde, periodoData?.fechaHasta])

  return { data, isLoading, error }
}
